import Row from './Row';
import Col from './Col';

export default {
  Row: Row,
  Col: Col
};


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/layout/index.js
// module id = 393
// module chunks = 0